import { Link, useLocation } from 'react-router-dom';
import { Home, UtensilsCrossed, MapPin, ShoppingBag } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { motion, AnimatePresence } from 'framer-motion';

const navItems = [
  { href: '/', label: 'Inicio', icon: Home },
  { href: '/menu', label: 'Menú', icon: UtensilsCrossed },
  { href: '/ubicaciones', label: 'Sucursales', icon: MapPin },
];

export function MobileNav() {
  const { itemCount, toggleCart } = useCart();
  const location = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-[9998] bg-background/95 backdrop-blur-lg border-t border-border/50 safe-area-inset-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map(item => {
          const Icon = item.icon;
          const isActive = location.pathname === item.href;
          
          return (
            <Link
              key={item.href}
              to={item.href}
              className={`flex flex-col items-center justify-center gap-1 py-2 px-4 rounded-xl transition-all ${
                isActive 
                  ? 'text-foreground' 
                  : 'text-muted-foreground'
              }`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'text-accent' : ''}`} />
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
        
        {/* Cart Button */}
        <button
          onClick={toggleCart}
          className="relative flex flex-col items-center justify-center gap-1 py-2 px-4 rounded-xl transition-all text-muted-foreground"
          data-testid="mobile-cart-button"
        >
          <div className="relative">
            <ShoppingBag className="w-5 h-5" />
            <AnimatePresence mode="wait">
              {itemCount > 0 && (
                <motion.span
                  key={itemCount}
                  initial={{ scale: 0.5, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.5, opacity: 0 }}
                  className="absolute -top-1.5 -right-1.5 bg-accent text-accent-foreground text-[10px] font-bold min-w-[18px] h-[18px] rounded-full flex items-center justify-center"
                >
                  {itemCount}
                </motion.span>
              )}
            </AnimatePresence>
          </div>
          <span className="text-xs font-medium">Carrito</span>
        </button>
      </div>
    </nav>
  );
}
